<template>
    <div class="sales-page">
        <div class="container" v-if="salesItems != null">
            <div class="page-title" v-if="setup != null">
                <h1>{{ setup.page_titles.sales_title }}</h1>
            </div>
        </div>
        <PromoSales></PromoSales>
        <formPage></formPage>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import PromoSales from '@/components/home-page/promo-sales.vue'
    import formPage from '@/components/forms/form-page.vue'
    import store from '@/store.js'
    export default {
        name: 'sales--page',
        components: {
            PromoSales,
            formPage,
        },
        metaInfo() {
            return {
                title: 'Надежный застройщик "DIAL GROUP" - Все проекты',
                meta: [
                    { name: 'description', content:  'Первичные квартиры комфорт-класса в Алмалинском районе от 24 000 000 тенге. В 10 минутах от MEGA Park. Готовые квартиры в ЖК бизнес-класса в золотом квадрате.'},
                ]
            };
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            salesItems: 'loadSalesItems',
        }),
        methods: {
        },
        beforeRouteEnter (to, from, next) {
            if (store.state.salesItems != null) {
                next();
            } else {
                store.dispatch('getSalesItems').then((response) => {
                    if (response) {
                        next();
                    } 
                    // else {
                    //     next(false, vm => vm.$parent.$refs.topProgress.fail());
                    // }
                });
            }
        },
        beforeCreate() {
            document.body.dataset.page = 'sales';
        },
        created () {
        },
        mounted() {
            this.$store.dispatch('getSalesItems');
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales-page/respond/sales-page-respond.scss';
</style>